if(!customElements.get('filter-upgrade')) {
  class FilterUpgrade extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      this.designMode = this.dataset.designMode === 'true';

      if(this.designMode) {
        return;
      }

      if(window.Shopify.shop == 'aprilaire.myshopify.com') {
        this.apiUrl = 'https://7ci5tne7xwzxxj3fkfa5oawgee0qlnii.lambda-url.us-west-2.on.aws/subscriptions';
      } else if (window.Shopify.shop == 'staging-aprilaire.myshopify.com') {
        this.apiUrl = 'https://yzl7y6kmjiz6h5s6tstx76rizu0vmbbp.lambda-url.us-west-2.on.aws/subscriptions';
      }
      else {
        return;
      }


      this.firstName = this.querySelector('.first-name');
      this.subscriptionDetails = this.querySelector('.subscription-details');
      this.subscriptionTable = this.subscriptionDetails.querySelector('.subscription__table');

      this.headings = this.querySelectorAll('.image-with-text__heading');

      this.upgradeButton = this.querySelector(`#UpgradeButton-${this.sectionId}`);
      this.successMessage = this.querySelector(`#SuccessMessage-${this.sectionId}`);

      this.subscriptionMessage = this.querySelector(`#SubscriptionMessage-${this.sectionId}`);

      this.urlParams = new URLSearchParams(window.location.search);

      this.customerId = this.urlParams.get('customer_id');

      this.subscriptions = [];

      this.init();

      this.upgradeButton.addEventListener('click', this.onClickHandler.bind(this));
    }

    init() {
      fetch(`${this.apiUrl}?customer_id=${this.customerId}`)
        .then((response) => {
          return response.json();
        })
        .then((data) => {

          console.log(data);

          if (data.status == "conflict") {
            this.subscriptionDetails.innerHTML = `
              <div class='subscription__success'>
                ${data.message}
              </div>
            `;

            this.headings.forEach(heading => {
              heading.innerHTML = heading.innerHTML.replace('{variant}', "");
            });

            this.upgradeButton.remove();

            return;
          }

          if(data.status == "error") {
            this.subscriptionDetails.innerHTML = `
              <div class='subscription__warning'>
                Something went wrong. Please contact our support team at <a class='link' href='mailto:support@aprilaire.com'>support@aprilaire.com</a> for assistance.
              </div>
            `;

            this.headings.forEach(heading => {
              heading.innerHTML = heading.innerHTML.replace('{variant}', "");
            });

            this.upgradeButton.remove();

            return;
          }          

          this.subscriptions = data.subscriptions || [];

          if(!this.subscriptions.length) {
            this.subscriptionDetails.innerHTML = `
              <div class='subscription__success'>
                We couldn't find any air filter subscriptions on your account.
              </div>
            `;

            this.headings.forEach(heading => {
              heading.innerHTML = heading.innerHTML.replace('{variant}', "");
            });

            this.upgradeButton.remove();

            return;
          }

          this.firstName.textContent = this.subscriptions[0].customer_first_name;

          this.renderSubscriptions();
        })
        .catch((error) => {
          console.error(error);

          this.subscriptionDetails.innerHTML = `
            <div class='subscription__warning'>
              Something went wrong. Please contact our support team at <a class='link' href='mailto:support@aprilaire.com'>support@aprilaire.com</a> for assistance.
            </div>
          `;

          this.headings.forEach(heading => {
            heading.innerHTML = heading.innerHTML.replace('{variant}', "");
          });
        });
    }

    renderSubscriptions() {
      const rows = this.subscriptions.map((subscription, index) => {
        const inputId = `Subscription-${this.sectionId}-${index}`;
        const optedOut = subscription.opted_out === true;

        return `
          <tr class="subscription__row${optedOut ? ' subscription__row--opted-out' : ''}">
            <td>
              <input
                id="${inputId}"
                class="subscription__checkbox"
                type="checkbox"
                name="subscription_id"
                value="${this.escape(subscription.id)}"
                ${optedOut ? 'disabled' : ''}
              >
            </td>

            <td>
              <label for="${inputId}">${this.escape(subscription.product_title)}</label>
              ${optedOut ? `<span class='subscription__status'>Opted out</span>` : ''}
            </td>

            <td>
              ${this.escape(subscription.variant_title)}
            </td>

            <td>
              ${this.escape(subscription.quantity)}
            </td>
          </tr>
        `;
      });

      this.subscriptionTable.querySelector('tbody').innerHTML = rows.join('');
    }

    /* Map the checked rows back onto the API objects so the payload keeps the
       original id/sku values instead of the stringified DOM versions. */
    getSelectedSubscriptions() {
      const checked = this.subscriptionTable.querySelectorAll('.subscription__checkbox:checked:not(:disabled)');

      return Array.from(checked)
        .map(checkbox => this.subscriptions.find(subscription => String(subscription.id) === checkbox.value))
        .filter(Boolean);
    }

    escape(value) {
      const element = document.createElement('div');

      element.textContent = value === null || value === undefined ? '' : value;

      return element.innerHTML;
    }

    onClickHandler(e) {
      e.preventDefault();

      const selected = this.getSelectedSubscriptions();

      let valid = true;

      if(!selected.length) {
        this.subscriptionMessage.classList.remove('hidden');
        valid = false;
      }
      else {
        this.subscriptionMessage.classList.add('hidden');
      }

      if(!valid) {
        return;
      }

      document.querySelectorAll(".filter-upgrade__button").forEach(button => {
        button.disabled = true;
        button.classList.add('loading');

        document.querySelectorAll(".filter-upgrade__loading").forEach(loadingMessage => {
          loadingMessage.classList.remove('hidden');
        });
      });

      const payload = {
        "customer_id": Number.isNaN(Number(this.customerId)) ? this.customerId : Number(this.customerId),
        "subscriptions": selected.map(subscription => ({
          "id": subscription.id,
          "sku": subscription.sku
        }))
      };

      fetch(`${this.apiUrl}/opt-out`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if(data.status == "ok") {
            selected.forEach(subscription => {
              subscription.opted_out = true;
            });

            this.renderSubscriptions();

            document.querySelectorAll(".filter-upgrade__success").forEach(successMessage => {
              successMessage.classList.remove('hidden');
            });

            /* Nothing left to act on once every subscription is opted out. */
            if(this.subscriptions.every(subscription => subscription.opted_out)) {
              document.querySelectorAll(".filter-upgrade__button").forEach(button => {
                button.innerHTML = "Successfully Opted Out";
              });
            }

            return;
          }

          this.subscriptionMessage.innerHTML = "Something went wrong. Please contact our support team at <a class='link' href='mailto:support@aprilaire.com'>support@aprilaire.com</a> for assistance.";
          this.subscriptionMessage.classList.remove('hidden');
        })
        .catch((error) => {
          console.error(error);

          this.subscriptionMessage.innerHTML = "Something went wrong. Please contact our support team at <a class='link' href='mailto:support@aprilaire.com'>support@aprilaire.com</a> for assistance.";
          this.subscriptionMessage.classList.remove('hidden');
        })
        .finally(() => {
          const remaining = this.subscriptions.some(subscription => !subscription.opted_out);

          document.querySelectorAll(".filter-upgrade__button").forEach(button => {
            button.classList.remove('loading');
            button.disabled = !remaining;
          });

          document.querySelectorAll(".filter-upgrade__loading").forEach(loadingMessage => {
            loadingMessage.classList.add('hidden');
          });
        });
    }
  }

  customElements.define('filter-upgrade', FilterUpgrade);
}
